<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TITULO' | translate}}</h2>
  <button mat-icon-button (click)="salir()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <mat-tab-group>
    <mat-tab label="{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.TITULO' | translate}}">
      <mat-list>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 mr-20">filter_1</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_1' | translate}}</p>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 mr-20">filter_2</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_2' | translate}}</p>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 ml-20 mr-20">navigate_next</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_2_1' | translate}}</p>
              <button mat-mini-fab class="ml-20">
                <mat-icon>zoom_in</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 ml-20 mr-20">navigate_next</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_2_2' | translate}}</p>
              <button mat-mini-fab class="ml-20">
                <mat-icon>link</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 mr-20">filter_3</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_3' | translate}}</p>
              <button mat-mini-fab class="ml-20">
                <mat-icon>add_a_photo</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 mr-20">filter_4</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_4' | translate}}</p>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 mr-20">filter_5</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_5' | translate}}</p>
              <button mat-mini-fab class="ml-20">
                <mat-icon>image</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="hta">
          <div fxLayout="row" fxLayoutAlign="start center" class="w100">
            <mat-icon class="s-30 mr-20">filter_6</mat-icon>
            <div fxLayout="row" class="mt-10 mb-10">
              <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.INSTRUCCIONES.PASO_6' | translate}}</p>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    </mat-tab>
    <mat-tab label="{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.TITULO' | translate}}">
      <ng-container *ngIf="cargandoImagenes; else imagenesCargadas">
        <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
          <p>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.CARGANDO' | translate}}</p>
          <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        </div>
      </ng-container>
      <ng-template #imagenesCargadas>
        <p *ngIf="!datos.carpetaBroker"><em>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.NOTA' |  translate}}</em></p>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <h3>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.TITULO_2' |  translate}}</h3>
          <button mat-raised-button color="primary" (click)="imagen.click()">
            {{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.ADD' |  translate}}
            <mat-icon class="ml-20">add_a_photo</mat-icon>
          </button>
        </div>
        <input #imagen type="file" (change)="openCropperDialog($event)" accept="image/*" hidden>
        <div fxLayout="row" fxLayoutAlign="space-around center" class="p-20">
          <h2 *ngIf="arregloImagenes.length == 0"><em>{{'EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.NOIMG' |  translate}}</em></h2>
          <div fxFlex="15" fxLayout="column" fxLayoutAlign="start center" class="mb-10" *ngFor="let imagen of arregloImagenes; let idxBg = index;">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <img [src]="imagen.image">
                <div class="divAcciones" fxLayout="row" fxLayoutAlign="space-evenly center">
                  <button mat-mini-fab matTooltip="{{'EDITOR.ELEMENTOS.TOOLTIPS.AMPLIAR' | translate}}" (click)="zoomImagen(imagen.image,1)">
                    <mat-icon>zoom_in</mat-icon>
                  </button>
                  <button mat-mini-fab matTooltip="{{'EDITOR.ELEMENTOS.TOOLTIPS.COPIARURL' | translate}}" (click)="copiarURL(imagen.image)">
                    <mat-icon>link</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
